import { useId } from 'react';
import { useSearchParams } from 'react-router';
import { t } from '../i18n/index.ts';
import { Icon } from './Icon.tsx';

/** The first-run greeting after a new account sets its password (`?welcome=1`); dismissing drops the flag. */
export function WelcomeNote({ className = '' }: { className?: string }) {
  const [params, setParams] = useSearchParams();
  const id = useId();
  if (params.get('welcome') !== '1') return null;
  const dismiss = () => {
    const next = new URLSearchParams(params);
    next.delete('welcome');
    setParams(next, { replace: true });
  };
  return (
    <section className={`welcome-note ${className}`} aria-labelledby={id} role="status">
      <span className="welcome-note__icon" aria-hidden="true"><Icon name="sparkle" size={17} /></span>
      <div className="welcome-note__body">
        <h2 className="welcome-note__title" id={id}>{t('welcome.note.title')}</h2>
        <p className="welcome-note__text">{t('welcome.note.body')}</p>
      </div>
      <button type="button" className="welcome-note__close" aria-label={t('welcome.note.dismiss')} onClick={dismiss}>
        <Icon name="close" size={16} />
      </button>
    </section>
  );
}
